'use strict';

/**
 * Model for saving the settings for the list view
 *
 * @category   Model
 * @module     shop
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var SettingsObjectListModel = require('modules/collection/models/settings-object-list');

var ShopSettingsObjectListModel = SettingsObjectListModel.extend({
    storageKey: 'module:collection:shop:list',

    basePath: '/shops',

    initialize: function(attributes, options) {
        SettingsObjectListModel.prototype.initialize.apply(this, arguments);

        this.set('isShop', true);
    },
});

module.exports = ShopSettingsObjectListModel;